import { FormatDate } from '../../../../shared/services';

const createDocHref = (document, state) => {
  const baseUrl = state.productDataLibraryUrl.substring(0, state.productDataLibraryUrl.indexOf('/', state.productDataLibraryUrl.indexOf('//') + 2));
  return `${baseUrl}${document.revisions.path}.${document.revisions.extension}`;
};

const getValidDocumentsWithLatestRevision = (documents, state) => {
  const validDocuments = documents.filter(document => state.excludedFileTypes.indexOf(document.type) === -1 && document.title != null);
  validDocuments.forEach(document => {
    document.revisions = document.revisions && document.revisions[document.latestRevision - 1];
    if (document.revisions && state.productDataLibraryUrl) {
      document.revisions.created = FormatDate(new Date(document.revisions.created * 1000), state.dateFormat);
      document.href = createDocHref(document, state);
    }
  });
  return validDocuments;
};

const buildState = ({ state, data }) => {
  state.documents = data && data.results ? getValidDocumentsWithLatestRevision(data.results, state) : null;
  state.documentCount = state.documents ? state.documents.length : 0;
  return state;
};

const initialState = () => {
  const rsWebProductModel = window.rs.web.product.model;
  return {
    productNumber: rsWebProductModel.productNumber,
    name: rsWebProductModel.name,
    productDataLibraryUrl: rsWebProductModel.productDataLibraryUrl ?
      rsWebProductModel.productDataLibraryUrl.replace('##PRODUCTNUMBER##', rsWebProductModel.productNumber).replace('http:', '') : null,
    excludedFileTypes: rsWebProductModel.excludedFileTypes,
    labels: rsWebProductModel.labels.technicalDocuments,
    documents: null,
    documentCount: null,
    showModal: false,
    dateFormat: rsWebProductModel.dateFormat,
    technicalDocumentsNotFound: rsWebProductModel.technicalDocumentsNotFound,
  };
};

export
{ initialState,
  buildState,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/TechnicalDocument/TechinicalDocumentState.js